import React from 'react';
import { PartnersList } from '../features/b2b';

const B2BPartnersPage = () => {
  return <PartnersList />;
};

export default B2BPartnersPage;